export const PARTNER = 'partner';

export const ENV_PRODUCTION = 'production'

export const ENV_DEVELOPMENT = 'development'

export const CURRENT_STAGE = ENV_PRODUCTION;
